import React, { useState } from 'react';
import CloseIcon from '../../../../../assets/icons/close.svg';
import { AuthenticatedPOSTRequest } from '../../../../../utils';

const AddClassModal = (props) => {
    const { open, onClose, onError } = props;
    const [loading, setLoading] = useState(false);
    const [classroom, setClassroom] = useState({
        department_urdu_name: 'حفظ و ناظرہ قرآن مجید',
        department_english_name: 'Hifz o Nazra Quran Majeed',
        name: '',
        english_name: '',
        section_count: 1,
        attendance_count: 1,
    });
    const departments = [
        { urdu_name: 'حفظ و ناظرہ قرآن مجید', english_name: 'Hifz o Nazra Quran Majeed' },
        { urdu_name: 'تجوید و قرأت', english_name: 'Tajweed o Qirat' },
        { urdu_name: 'درس نظامی', english_name: 'Darse Nizami' },
    ];

    const addClass = async (classroom) => {
        try {
            const { success } = await AuthenticatedPOSTRequest('class_rooms', classroom);
            setLoading(false);
            onClose();
            if (success) {
                window.location.reload();
            } else {
                onError('مہرنانی، کچھ غلط ہو گیا ہے۔ دوبارہ کوشش کریں۔');
            }
        } catch (error) {
            onError('مہرنانی، کچھ غلط ہو گیا ہے۔ دوبارہ کوشش کریں۔');
            setLoading(false);
        }
    };
    const onSubmit = () => {
        if (classroom.department_urdu_name === '') {
            onError('مہرنانی، شعبہ منتخب کریں');
            return;
        }
        if (classroom.name === '') {
            onError('مہرنانی، کلاس کا نام درج کریں');
            return;
        }
        if (classroom.english_name === '') {
            onError('مہرنانی، کلاس کا نام درج کریں');
            return;
        }
        if (classroom.section_count === 0) {
            onError('مہرنانی، کلاس کے سیکشنز کی تعداد درج کریں');
            return;
        }
        if (classroom.attendance_count === 0) {
            onError('مہرنانی، کلاس کا نام درج کریں');
            return;
        }
        addClass(classroom);
    };

    return open ? (
        <div
            className='flex column justifyCenter alignCenter'
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1000,
                background: 'rgba(0,0,0,0.7)',
            }}
        >
            <div
                style={{
                    background: '#ffffff',
                    height: 475,
                    maxHeight: 475,
                    width: 768,
                    borderRadius: 8,
                }}
            >
                <div className='h-100 w-100' style={{ overflow: 'auto', position: 'relative' }}>
                    <div
                        className='flex justifyBetween alignCenter w-100'
                        style={{
                            borderBottom: '1px solid #E0E0E0',
                            padding: '20px 16px 8px',
                            height: 72,
                        }}
                    >
                        <h2 className='flex alignCenter w-100' style={{ color: '#009688' }}>
                            نئی کلاس کا ریکارڈ درج کریں
                        </h2>
                        <img
                            src={CloseIcon}
                            alt='close_icon'
                            height={32}
                            width={32}
                            onClick={props.onClose}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>

                    {/* form */}
                    <div
                        className='flex column justifyCenter alignCenter urdu'
                        style={{ padding: 20, height: 'calc(100% - 156px)' }}
                    >
                        <div className='flex justifyBetween alignCenter w-100'>
                            {/* Department urdu name */}
                            <div className='form-container'>
                                <label htmlFor='department_urdu_name'>
                                    شعبہ منتخب کریں (اردو)
                                    <span className='required'>*</span>
                                </label>
                                <select
                                    name='department_urdu_name'
                                    style={{ height: 44, fontSize: 20, padding: 4 }}
                                    value={classroom['department_urdu_name']}
                                    onChange={(event) => {
                                        if (event.target.value.length > 0) {
                                            const selected_dept = departments.find(
                                                (e) => e.urdu_name === event.target.value,
                                            );
                                            setClassroom({
                                                ...classroom,
                                                department_urdu_name: selected_dept.urdu_name,
                                                department_english_name: selected_dept.english_name,
                                            });
                                        }
                                    }}
                                >
                                    {departments.map((item, index) => (
                                        <option
                                            value={item.urdu_name}
                                            key={index + 1}
                                            selected={
                                                classroom['department_urdu_name'] === item.urdu_name
                                            }
                                        >
                                            {item.urdu_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {/* Department english name */}
                            <div className='form-container'>
                                <label htmlFor='department_english_name'>
                                    شعبہ منتخب کریں (انگلش)
                                    <span className='required'>*</span>
                                </label>
                                <select
                                    disabled
                                    name='department_english_name'
                                    style={{
                                        height: 44,
                                        fontSize: 18,
                                        padding: 4,
                                        fontFamily: 'CircularStd',
                                    }}
                                    onChange={(event) => {
                                        if (event.target.value.length > 0) {
                                            const selected_dept = departments.find(
                                                (e) => e.urdu_name === event.target.value,
                                            );
                                            setClassroom({
                                                ...classroom,
                                                department_english_name: selected_dept.english_name,
                                                department_urdu_name: selected_dept.urdu_name,
                                            });
                                        }
                                    }}
                                >
                                    {departments.map((item, index) => (
                                        <option
                                            value={item.english_name}
                                            key={index + 1}
                                            selected={
                                                classroom['department_english_name'] ===
                                                item.english_name
                                            }
                                        >
                                            {item.english_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='flex justifyBetween alignCenter w-100'>
                            {/* Urdu name */}
                            <div className='form-container'>
                                <label htmlFor='class_name_urdu'>
                                    کلاس کا نام درج کریں (اردو)
                                    <span className='required'>*</span>
                                </label>
                                <input
                                    type='text'
                                    id='class_name_urdu'
                                    name='class_name_urdu'
                                    value={classroom.name}
                                    onKeyUp={(event) => {
                                        if (event.keyCode === 13) {
                                            setClassroom({
                                                ...classroom,
                                                name: event.target.value,
                                            });
                                            onSubmit();
                                        }
                                    }}
                                    onChange={(event) => {
                                        if (event.target.value.length > 0) {
                                            setClassroom({
                                                ...classroom,
                                                name: event.target.value,
                                            });
                                        } else {
                                            setClassroom({ ...classroom, name: '' });
                                        }
                                    }}
                                />
                            </div>
                            {/* English name */}
                            <div className='form-container'>
                                <label htmlFor='class_name_english'>
                                    کلاس کا نام درج کریں (انگلش)
                                    <span className='required'>*</span>
                                </label>
                                <input
                                    type='text'
                                    id='class_name_english'
                                    name='class_name_english'
                                    value={classroom.english_name}
                                    style={{ fontFamily: 'CircularStd' }}
                                    onKeyUp={(event) => {
                                        if (event.keyCode === 13) {
                                            setClassroom({
                                                ...classroom,
                                                english_name: event.target.value,
                                            });
                                            onSubmit();
                                        }
                                    }}
                                    onChange={(event) => {
                                        if (event.target.value.length > 0) {
                                            setClassroom({
                                                ...classroom,
                                                english_name: event.target.value,
                                            });
                                        } else {
                                            setClassroom({ ...classroom, english_name: '' });
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className='flex justifyBetween alignCenter w-100'>
                            {/* Section Count */}
                            <div className='form-container'>
                                <label htmlFor='section_count'>
                                    کلاس کے سیکشنز کی تعداد درج کریں
                                    <span className='required'>*</span>
                                </label>
                                <input
                                    type='number'
                                    min={1}
                                    max={9}
                                    id='section_count'
                                    name='section_count'
                                    style={{ fontFamily: 'CircularStd' }}
                                    value={classroom.section_count}
                                    onKeyUp={(event) => {
                                        if (event.keyCode === 13) {
                                            setClassroom({
                                                ...classroom,
                                                section_count: event.target.value,
                                            });
                                            onSubmit();
                                        }
                                    }}
                                    onChange={(event) => {
                                        if (event.target.value.length > 0) {
                                            setClassroom({
                                                ...classroom,
                                                section_count: event.target.value,
                                            });
                                        } else {
                                            setClassroom({ ...classroom, section_count: 0 });
                                        }
                                    }}
                                />
                            </div>
                            {/* Attendance Count */}
                            <div className='form-container'>
                                <label htmlFor='attendance_count'>
                                    کلاس کی یومیہ حاضری کی تعداد درج کریں
                                    <span className='required'>*</span>
                                </label>
                                <input
                                    type='number'
                                    min={1}
                                    max={5}
                                    id='attendance_count'
                                    name='attendance_count'
                                    style={{ fontFamily: 'CircularStd' }}
                                    value={classroom.attendance_count}
                                    onKeyUp={(event) => {
                                        if (event.keyCode === 13) {
                                            setClassroom({
                                                ...classroom,
                                                attendance_count: event.target.value,
                                            });
                                            onSubmit();
                                        }
                                    }}
                                    onChange={(event) => {
                                        if (event.target.value.length > 0) {
                                            setClassroom({
                                                ...classroom,
                                                attendance_count: event.target.value,
                                            });
                                        } else {
                                            setClassroom({ ...classroom, attendance_count: 0 });
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* button */}
                    <div
                        className='flex justifyEnd alignCenter w-100'
                        style={{ height: 72, paddingLeft: 16 }}
                    >
                        <div className='flex justifyBetween alignCenter'>
                            <div
                                className='flex justifyEnd alignCenter register_button'
                                style={{ margin: '0 8px' }}
                                onClick={() => onSubmit()}
                            >
                                {loading ? (
                                    <div className='custom_loader' />
                                ) : (
                                    <h3>{`محفوظ کریں`}</h3>
                                )}
                            </div>
                            <div
                                className='flex justifyEnd alignCenter delete_button'
                                style={{ margin: '0 8px' }}
                                onClick={onClose}
                            >
                                <h3>{`منسوخ کریں`}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : null;
};

export default AddClassModal;
